export const YoutubeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="currentColor"
      className="h-6 w-6 opacity-80 transition-opacity duration-200 hover:opacity-100 lg:h-8 lg:w-8"
    >
      <path d="M31.33 8.25A4 4 0 0 0 28.5 5.4C26 4.73 16 4.73 16 4.73s-10 0-12.5.67A4 4 0 0 0 .67 8.25 42.07 42.07 0 0 0 0 16a42.07 42.07 0 0 0 .67 7.75A4 4 0 0 0 3.5 26.6c2.49.67 12.5.67 12.5.67s10 0 12.5-.67a4 4 0 0 0 2.83-2.85A42.07 42.07 0 0 0 32 16a42.07 42.07 0 0 0-.67-7.75zm-18.6 12.51v-9.52L21.09 16z"></path>
    </svg>
  );
};
